export class EnergySubtype {
	id: number;
	name: string;
	isDefault: boolean;
}
